/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Water_ActivityInputs */

const en_water_activity = /** @type {(inputs: Water_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water Activity`)
};

const es_water_activity = /** @type {(inputs: Water_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad de agua`)
};

/**
* | output |
* | --- |
* | "Water Activity" |
*
* @param {Water_ActivityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const water_activity = /** @type {((inputs?: Water_ActivityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Water_ActivityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_water_activity(inputs)
	return es_water_activity(inputs)
});